const landing: LandingBSetup = {
    background: '/assets/landing/background.png',
    title: 'Plinkromatic',
    text: `<p>This simple innovation game explains how funding decisions can impact ROI.</p>
            <p><b>You'll play the new VP of Innovation responsible for setting up an innovation program.</b></p>`,
    registrationTitle: 'Play the game:',
    registrationText: 'You will receive access to all Kromatic resources, news and updates.',
    startButton: 'Kick off an idea',
    illustration: '/assets/landing/illustration.png',
    illustrationAlt: 'Illustration of innovation ideas moving through stage gates',
    point1: {
        icon: '/assets/landing/savings.svg',
        iconAlt: 'Savings icon representing budget and ROI calculations',
        label: 'Calculating budgets and ROI',
    },
    point2: {
        icon: '/assets/landing/bar_chart_4_bars.svg',
        iconAlt: 'Bar chart icon representing data-driven decisions',
        label: 'Making data-driven decisions',
    },
    point3: {
        icon: '/assets/landing/saved_search.svg',
        iconAlt: 'Search icon representing prediction and analysis',
        label: 'Predicting expected project ROI',
    },
    point4: {
        icon: '/assets/landing/timeline.svg',
        iconAlt: 'Timeline icon representing decision timing',
        label: 'Timing decisions optimally',
    },
    point5: {
        icon: '/assets/landing/attach_money.svg',
        iconAlt: 'Money icon representing cost optimization',
        label: 'Optimizing costs',
    },
    point6: {
        icon: '/assets/landing/undo.svg',
        iconAlt: 'Undo icon representing pivot impact measurement',
        label: 'Measuring the impact of pivots',
    },
};

export { landing };
